import React from "react";

import { Trans } from "@lingui/react/macro";

import Stack from "@readai/pulse/components/Stack";

import EventNotification, {
  EventNotificationDescription,
  EventNotificationTitle,
  ReturnToRead,
} from "@app/booking/components/EventNotification";

const EventCanceled = ({ ownerName }: { ownerName?: string }) => (
  <EventNotification>
    <Stack spacing={1}>
      <EventNotificationTitle>
        <Trans>Cancellation confirmed</Trans>
      </EventNotificationTitle>
      <EventNotificationDescription>
        {ownerName ? (
          <Trans>Your meeting with {ownerName} has been cancelled.</Trans>
        ) : (
          <Trans>Your meeting has been cancelled.</Trans>
        )}
      </EventNotificationDescription>
    </Stack>
    <ReturnToRead />
  </EventNotification>
);

export default EventCanceled;
